var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"title":_vm.title}},[_c('alert_triangle_icon',{staticClass:"w-5 h-5",staticStyle:{"fill":"currentColor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }